/**
 * @generated SignedSource<<7926b7f40bab48224fd58648fac831f4>>
 * @relayHash 1f76887d80ab54c5ed58b9cac736e99c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 18799054b9f9df47ee35aa2417ce2a89320a98ac0173871a1d2c3c5699487081

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraFieldSetPreferencesMutationInput = {
  nodes?: ReadonlyArray<JiraUpdateFieldSetPreferencesInput> | null | undefined;
};
export type JiraUpdateFieldSetPreferencesInput = {
  fieldSetId: string;
  isFrozen?: boolean | null | undefined;
  width?: number | null | undefined;
};
export type JiraIssueSearchViewFieldSetsContext = {
  filterContext?: JiraIssueSearchViewFieldSetFilterContext | null | undefined;
  issueContext?: JiraIssueSearchViewFieldSetsIssueContext | null | undefined;
  projectContext?: JiraIssueSearchViewFieldSetsProjectContext | null | undefined;
};
export type JiraIssueSearchViewFieldSetFilterContext = {
  filter?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsIssueContext = {
  issueKey?: string | null | undefined;
};
export type JiraIssueSearchViewFieldSetsProjectContext = {
  issueType?: string | null | undefined;
  project?: string | null | undefined;
};
export type main_updateFieldSetPreferencesOldMutation$variables = {
  cloudId: string;
  context?: JiraIssueSearchViewFieldSetsContext | null | undefined;
  input: JiraFieldSetPreferencesMutationInput;
  viewId?: string | null | undefined;
};
export type main_updateFieldSetPreferencesOldMutation$data = {
  readonly jira: {
    readonly updateUserFieldSetPreferences: {
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type main_updateFieldSetPreferencesOldMutation = {
  response: main_updateFieldSetPreferencesOldMutation$data;
  variables: main_updateFieldSetPreferencesOldMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "context"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v4 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
          },
          {
            "kind": "Variable",
            "name": "context",
            "variableName": "context"
          },
          {
            "kind": "Variable",
            "name": "fieldSetPreferencesInput",
            "variableName": "input"
          },
          {
            "kind": "Variable",
            "name": "viewId",
            "variableName": "viewId"
          }
        ],
        "concreteType": "JiraFieldSetPreferencesUpdatePayload",
        "kind": "LinkedField",
        "name": "updateUserFieldSetPreferences",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "main_updateFieldSetPreferencesOldMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "main_updateFieldSetPreferencesOldMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "id": "18799054b9f9df47ee35aa2417ce2a89320a98ac0173871a1d2c3c5699487081",
    "metadata": {},
    "name": "main_updateFieldSetPreferencesOldMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "79dafbbd02110a6070a65f2d9ad7f6a9";

export default node;
